import React from 'react';
import BillingField from './BillingField';
import { IBillingValues, SelectItem } from '../types/locationTypes';
import CommonRow from './CommonRow';
import { useStylesForForms } from './billingHelpers';

interface BillingFormType4Props {
    billingValuesObj: IBillingValues,
    handleSetBillingValuesObj: any,
    disabled: boolean,
    retainerIntervals: SelectItem[],
}

const BillingFormType4: React.FC<BillingFormType4Props> = ({
    billingValuesObj,
    handleSetBillingValuesObj,
    disabled,
    retainerIntervals,
}) => {
    const classes = useStylesForForms();
    return (
        <>
            <div className={classes.flexContainer}>
                <div>
                    <hr className={classes.separator} />
                </div>
                <div className={classes.row}>
                    <BillingField
                        title="PER TRANSFER FEE ($)"
                        description="Fee to be applied for each transfer booked by this location."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.perTransferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('perTransferFees', newValue)}
                    />
                    <BillingField
                        title="FREE DISTANCE (KM)"
                        description="Portion of transfer distance that doesn’t incur the per km fee."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.freeDistance}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('freeDistance', newValue)}
                    />
                    <BillingField
                        title="PER KM FEE ($)"
                        description="Amount charged per km above the free distance."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.perKmFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('perKmFees', newValue)}
                    />
                    <BillingField
                        title="FEE CAP ($)"
                        description="Cap for transfers started within service hours."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.feeCap}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('feeCap', newValue)}
                    />
                </div>
                <div>
                    <hr className={classes.separator} />
                </div>
                <CommonRow
                    billingValuesObj={billingValuesObj}
                    handleSetBillingValuesObj={handleSetBillingValuesObj}
                    disabled={disabled}
                    parentClasses={classes}
                    retainerIntervals={retainerIntervals}
                />
            </div>

        </>
    );
}

export default BillingFormType4;